import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { REQUIRED_FEATURE_FLAGS } from 'helpers/sf_constants';
import { bsh_isAdminUserDetailsPresent } from 'helpers/sf_browser_storage_helper';
import { getIntegrationPermissions } from 'helpers/sf_integration_permissions_helper';
import useFeatureFlagsForAccounts from './useFeatureFlagsForAccounts';

// BM-9524: { flagOn, enforced, canView, canManage } for the current
// user and account. See getIntegrationPermissions.
const useIntegrationPermissions = () => {
    const [isFeatureFlagActiveForAccount] = useFeatureFlagsForAccounts();
    const { current_account, current_role_permissions_state } = useSelector(state => ({
        current_account: state.accounts.current_account,
        current_role_permissions_state: state.Role.current_role_permissions_state,
    }));

    const flagOn = isFeatureFlagActiveForAccount(
        REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_INTEGRATION_ROLE_PERMISSIONS,
        current_account
    );

    return useMemo(() => getIntegrationPermissions({
        flagOn,
        isAdmin: bsh_isAdminUserDetailsPresent(),
        rolePermissions: current_role_permissions_state,
    }), [flagOn, current_role_permissions_state]);
}

export default useIntegrationPermissions;
